// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"7bbc64d7","112":"bff72ff9","176":"02150471","372":"278e294d","411":"63665d25","522":"682357c3","603":"83d3294f","762":"e550d90a","912":"c0aa445f"}[chunkId] + ".chunk.js";
};